import React from 'react';
import classNames from 'classnames';
import { SectionSplitProps } from '../../utils/SectionProps';
import SectionHeader from './partials/SectionHeader';

const propTypes = {
  ...SectionSplitProps.types
}

const defaultProps = {
  ...SectionSplitProps.defaults
}

const FaqView = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  invertMobile,
  invertDesktop,
  alignTop,
  imageFill,
  ...props
}) => {

  const outerClasses = classNames(
    'features-split section',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'features-split-inner section-inner',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider'
  );

  const splitClasses = classNames(
    'split-wrap',
    invertMobile && 'invert-mobile',
    invertDesktop && 'invert-desktop',
    alignTop && 'align-top'
  );

  const sectionHeader = {
    title: 'Frequently Asked Questions',
    paragraph: 'Here you can find the most frequently asked Questions and their Answers.'
  };

  return (
    <section
      {...props}
      className={outerClasses}
    >
      <div className="container">
        <div className={innerClasses}>
          <SectionHeader data={sectionHeader} className="center-content" />
          <div className={splitClasses}>



            <div className="split-item">
              <div className="split-item-content center-content-mobile reveal-from-right" data-reveal-container=".split-item">
                <div className="text-xxs text-color-primary fw-600 tt-u mb-8">
                  What is SERS Spectroscopy?
                  </div>
                <h3 className="mt-0 mb-12">
                What is SERS Spectroscopy?
                  </h3>
                <p className="m-0">
                  SERS Spectroscopy is an analytical technique that uses optics and light to measure vibrations of molecules in the vicinity of a special gold nanoparticle sensor. Digitizing these light signals enables data analysis for comparison with a database that allows for identification of vibration spectra by correlating data with known spectral signatures. 
                  </p>
              </div>
            </div>


            <div className="split-item">
              <div className="split-item-content center-content-mobile reveal-from-left" data-reveal-container=".split-item">
                <div className="text-xxs text-color-primary fw-600 tt-u mb-8">
                  How Does It Work?
                  </div>
                <h3 className="mt-0 mb-12">
                How does it work?
                  </h3>
                <p className="m-0">
                  The SPPMobileSense System uses High Speed Electronics to Generate Optical Signals that illuminate the Sample Fluid, and measure the Optical Response.
                  </p>
              </div>
            </div>

            <div className="split-item">
              <div className="split-item-content center-content-mobile reveal-from-right" data-reveal-container=".split-item">
                <div className="text-xxs text-color-primary fw-600 tt-u mb-8">
                  What Types of Data are Collected?
                  </div>
                <h3 className="mt-0 mb-12">
                What Types of Data are Collected?
                  </h3>
                <p className="m-0">
                  The SPPMobileSense System Collects Physical and Chemical Information from the Fluid Samples. Volume, Turbidity, Color, Conductivity, and Chemical Information Signals are stored.
                  </p>
              </div>
            </div>
            <div className="split-item">
              <div className="split-item-content center-content-mobile reveal-from-right" data-reveal-container=".split-item">
                <div className="text-xxs text-color-primary fw-600 tt-u mb-8">
                  Why It Matters:
                  </div>
                <h3 className="mt-0 mb-12">
                How Much Fluid is Required?
                  </h3>
                <p className="m-0">
                  The system performs optimally with a sample volumes of 80mL or more of fluid. Customizations can be performed to reduce the sample volume required. 
                  Dilution of Samples fluids can be performed to meet volume requirements. 
                  </p>
              </div>
            </div>


          </div>
        </div>
      </div>
    </section>
  );
}

FaqView.propTypes = propTypes;
FaqView.defaultProps = defaultProps;

export default FaqView;